import { cycleReportConstants } from "../../constants/client";

export const cycleReport = {
  cycleReportListing,
  cycleReportListingSuccess,
  cycleReportListingFailure,
  cycleReportDownload,
  cycleReportDownloadSuccess,
  cycleReportDownloadFailure
};

function cycleReportListing(payload) {
  return { type: cycleReportConstants.CYCLE_REPORT_LISTING_REQUEST, payload };
}

function cycleReportListingSuccess(payload) {
  return { type: cycleReportConstants.CYCLE_REPORT_LISTING_SUCCESS, payload };
}

function cycleReportListingFailure(error) {
  return { type: cycleReportConstants.CYCLE_REPORT_LISTING_FAILURE, error };
}

function cycleReportDownload(payload) {
  return { type: cycleReportConstants.CYCLE_REPORT_DOWNLOAD_REQUEST, payload };
}

function cycleReportDownloadSuccess(payload) {
  return { type: cycleReportConstants.CYCLE_REPORT_DOWNLOAD_SUCCESS, payload };
}

function cycleReportDownloadFailure(payload) {
  return { type: cycleReportConstants.CYCLE_REPORT_DOWNLOAD_FAILURE, payload };
}
